(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 30) { this.header.classList.add('mv-scrolled'); } else { this.header.classList.remove('mv-scrolled'); }
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
      else { window.clearTimeout(this.isScrolling); this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66); requestAnimationFrame(this.hide.bind(this)); }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
  reveal() { if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
  reset() { if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
  closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(d => d.close()); }
  closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); if (this.searchModal) this.searchModal.close(false); }
}
customElements.define('sticky-header', StickyHeader);

(function() {
  const trigger = document.querySelector('.mv-search-trigger');
  const overlay = document.querySelector('#mv-search-modal');
  const closeBtn = overlay && overlay.querySelector('.mv-search-close');
  const input = overlay && overlay.querySelector('.mv-search-input');
  const resetBtn = overlay && overlay.querySelector('.mv-search-reset');
  if (!trigger || !overlay) return;
  function openSearch() {
    overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true'); document.body.classList.add('mv-search-open');
    if (input) setTimeout(() => input.focus(), 50);
    document.addEventListener('keydown', onEscape); document.addEventListener('click', onOutsideClick);
  }
  function closeSearch() {
    overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false'); document.body.classList.remove('mv-search-open');
    document.removeEventListener('keydown', onEscape); document.removeEventListener('click', onOutsideClick);
    trigger.focus();
  }
  function onEscape(e) { if (e.key === 'Escape') closeSearch(); }
  function onOutsideClick(e) { if (!overlay.contains(e.target) && !trigger.contains(e.target)) closeSearch(); }
  trigger.addEventListener('click', function(e) { e.stopPropagation(); overlay.classList.contains('is-open') ? closeSearch() : openSearch(); });
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (resetBtn && input) {
    input.addEventListener('input', function() { resetBtn.classList.toggle('hidden', input.value === ''); });
    resetBtn.addEventListener('click', function() { input.value = ''; resetBtn.classList.add('hidden'); input.focus(); });
  }
})();

(function() {
  var wraps = document.querySelectorAll('.mv-mega-wrap[data-mega]');
  wraps.forEach(function(wrap) {
    var id = wrap.dataset.mega;
    var panel = document.getElementById('mv-mega-' + id);
    if (!panel) return;
    var timer;
    function openPanel() {
      clearTimeout(timer);
      document.querySelectorAll('.mv-mega').forEach(function(p) { p.classList.remove('mv-mega--open'); });
      document.querySelectorAll('.mv-mega-wrap').forEach(function(w) { w.classList.remove('mv-mega-active'); });
      panel.classList.add('mv-mega--open'); wrap.classList.add('mv-mega-active');
    }
    function closePanel() { timer = setTimeout(function() { panel.classList.remove('mv-mega--open'); wrap.classList.remove('mv-mega-active'); }, 120); }
    wrap.addEventListener('mouseenter', openPanel); wrap.addEventListener('mouseleave', closePanel);
    panel.addEventListener('mouseenter', function() { clearTimeout(timer); }); panel.addEventListener('mouseleave', closePanel);
  });
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.mv-mega-wrap') && !e.target.closest('.mv-mega')) {
      document.querySelectorAll('.mv-mega').forEach(function(p) { p.classList.remove('mv-mega--open'); });
      document.querySelectorAll('.mv-mega-wrap').forEach(function(w) { w.classList.remove('mv-mega-active'); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-js-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const heroEl = document.getElementById("heroSwiper");
    if (!heroEl) return;
    const isSingle = heroEl.classList.contains("hero-js-slider--single");

    const swiper = new Swiper("#heroSwiper", {
      loop: !isSingle,
      autoplay: isSingle ? false : {
        delay: 5000,
        disableOnInteraction: false
      },
      speed: 800,
      effect: "slide",
      allowTouchMove: !isSingle,
      pagination: isSingle ? false : {
        el: ".swiper-pagination",
        clickable: true
      },
      navigation: isSingle ? false : {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      grabCursor: !isSingle,

      on: {
        init: function () {
          animateSlide(this.slides[this.activeIndex]);
        },
        slideChangeTransitionStart: function () {
          resetAnimations(this.slides);
        },
        slideChangeTransitionEnd: function () {
          animateSlide(this.slides[this.activeIndex]);
        }
      }
    });

    const pauseBtn = document.querySelector('.hero-slider__pause');
    pauseBtn?.addEventListener('click', () => {
      const paused = pauseBtn.getAttribute('aria-pressed') === 'true';
      if (paused) {
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }
      pauseBtn.setAttribute('aria-pressed', String(!paused));
      pauseBtn.querySelector('.hero-slider__pause-icon--pause').hidden = !paused;
      pauseBtn.querySelector('.hero-slider__pause-icon--play').hidden = paused;
    });

    function resetAnimations(slides) {
      slides.forEach(slide => {
        const content = slide.querySelector(".hero-content");
        const btn = slide.querySelector(".hero-btn");
        const link = slide.querySelector(".hero-secondary-link");
        if (content) content.classList.remove("animate-in");
        if (btn) btn.classList.remove("animate-in");
        if (link) link.classList.remove("animate-in");
      });
    }

    function animateSlide(slide) {
      const content = slide.querySelector(".hero-content");
      const btn = slide.querySelector(".hero-btn");
      const link = slide.querySelector(".hero-secondary-link");

      setTimeout(() => {
        if (content) content.classList.add("animate-in");
        if (btn) btn.classList.add("animate-in");
        if (link) link.classList.add("animate-in");
      }, 200);
    }

  });

  } catch(e) { console.error(e); }
})();
})();
